<template>
  <section
    class="component-d494790c"
    resmed-component-name="feature_fullwidth_icon-line_h54_text_cta"
  >
    <div
      class="component -transition-in-view"
      v-bind:class="{
        [`placement-${acf.layout['content-placement']}`]: true,
        [`text-color-${acf.layout['text-color']}`]: true,
      }"
    >
      <div
        class="embed-responsive"
        v-bind:class="{
          'embed-responsive-21by9': $root.mode === 'xl',
          'embed-responsive-16by9': ['xs', 'sm', 'lg'].includes($root.mode),
          'embed-responsive-4by3': $root.mode === 'md',
        }"
        v-bind:style="{
          background: acf.layout['background-color'],
          'background-size': 'cover',
          'background-position': 'center top',
          'background-repeat': 'no-repeat',
        }"
      >
        <div class="hero-bg embed-responsive-item" v-bind:style="style"></div>
      </div>

      <div class="wrapper px-xs-sm-2">
        <div class="container">
          <div class="row">
            <div
              class="col"
              v-bind:class="{
                'col-md-7 offset-lg-1':
                  acf.layout['content-placement'] === 'left',
                'col-md-8 offset-md-2':
                  acf.layout['content-placement'] === 'center',
                'col-md-7 offset-md-5':
                  acf.layout['content-placement'] === 'right',
              }"
            >
              <div v-bind:style="transform">
                <eyebrow-icon
                  v-if="acf.eyebrowicon"
                  v-bind:eyebrowicon="acf.eyebrowicon"
                  v-bind:align="
                    acf.layout['content-placement'] === 'center' ? 'center' : ''
                  "
                ></eyebrow-icon>
                <h1
                  v-if="acf.layout['heading-tag'] === 'h1'"
                  v-html="acf.headline"
                  v-bind:class="{ '-has-eyebrow': acf.eyebrow }"
                ></h1>
                <h2
                  v-if="acf.layout['heading-tag'] === 'h2'"
                  v-html="acf.headline"
                  v-bind:class="{ '-has-eyebrow': acf.eyebrow }"
                ></h2>

                <div
                  v-if="acf.introduction"
                  v-html="acf.introduction"
                  class="introduction pt-3 pb-4"
                ></div>

                <!-- call to action -->
                <div v-if="acf.cta.length">
                  <template v-if="acf.cta.length >= 1">
                    <!-- first cta, with modal option -->
                    <a
                      v-if="acf.modal.player"
                      href="#"
                      class="btn cta-pill filled-red icon right-arrow mb-2 mr-2"
                      v-bind:modal-video-id="acf.modal.id"
                      v-on:click.prevent="modal(acf.modal.player, acf.modal.id)"
                      >{{ acf.cta[0].cta.text }}</a
                    >
                    <a
                      v-else
                      v-bind:href="acf.cta[0].cta.href"
                      v-bind:target="acf.cta[0].cta.target"
                      class="btn cta-pill filled-red icon right-arrow mb-2 mr-2"
                      >{{ acf.cta[0].cta.text }}</a
                    >
                  </template>

                  <!-- second cta: optional. no modal -->
                  <a
                    v-if="acf.cta.length === 2"
                    v-bind:href="acf.cta[1].cta.href"
                    v-bind:target="acf.cta[1].cta.target"
                    class="btn cta-pill hallow-white icon right-arrow mb-2 mr-2"
                    >{{ acf.cta[1].cta.text }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-d494790c", // feature_fullwidth_icon-line_h54_text_cta
  props: ["acf"],
  data() {
    return {
      style: {},
      transform: {
        transform: "",
      },
    };
  },
  watch: {
    "$root.mode": {
      handler(val) {
        if (val === "xs" || val === "sm") {
          this.style["background-image"] = this.acf.layout[
            "background-image-xs"
          ]
            ? `url(${this.acf.layout["background-image-xs"]})`
            : `url(${this.acf.layout["background-image"]})`;

          this.transform["transform"] = this.acf.layout["transform-xs"];
        } else {
          this.style[
            "background-image"
          ] = `url(${this.acf.layout["background-image"]})`;
          this.transform["transform"] = "";
        }

        if (this.acf.layout["background-position"]) {
          this.style["background-position"] =
            this.acf.layout["background-position"];
        }
      },
      immediate: true,
    },
  },
  methods: {
    modal(...arg) {
      bus.$emit("overlay:active", {
        active: true,
        player: arg[0],
        id: arg[1],
      });
    },
  },
  created() {
    bus.$emit("navigation:reversed", true);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component {
  position: relative;

  &.placement-center {
    text-align: center;

    h1,
    h2 {
      &.-has-eyebrow {
        position: relative;
        @extend %eyebrow-center;
      }
    }
  }

  &.placement-left,
  &.placement-right {
    h1,
    h2 {
      &.-has-eyebrow {
        position: relative;
        @extend %eyebrow-left;
      }
    }
  }

  &.text-color-black {
    h1,
    h2 {
      color: $cc-resmed-black;

      &.-has-eyebrow {
        &:before {
          background-color: $cc-resmed-black;
        }
      }
    }

    .introduction * {
      color: $cc-resmed-black;
    }
  }

  &.text-color-white {
    h1,
    h2 {
      color: rgba($cc-resmed-white, 0.875);

      &.-has-eyebrow {
        &:before {
          background-color: $cc-resmed-white;
        }
      }
    }

    .introduction * {
      color: $cc-resmed-white;
    }
  }

  h1,
  h2 {
    margin: 0 0 0.325rem 0;
  }

  h5 {
    ~ h2 {
      &:before {
        top: -1.325rem !important;
      }
    }
  }

  .embed-responsive {
    .hero-bg {
      background-size: cover;
      background-position: center top;
      background-repeat: no-repeat;
    }
  }

  .wrapper {
    @media (max-width: 767px) {
      background-color: #374554;
      padding: 4rem 0 3rem 0;
    }

    @media (min-width: 768px) {
      min-width: 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>